import React from "react"
import { Route, Redirect } from "react-router-dom"
import Layout from "components/Layout"
import { LOCAL_TOKEN } from "../../utils/storage"

const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        LOCAL_TOKEN() ? (
          <Layout>
            <Component {...props} />
          </Layout>
        ) : (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        )
      }
    />
  )
}

PrivateRoute.propTypes = {}

export default PrivateRoute
